import * as Sentry from "@sentry/react"
import { env } from "configs/EnvironmentConfig"

export const SENTRY_SESSION_KEY = "sentry_sid"

export const initializeSentry = (): void => {
  const dsn = import.meta.env.VITE_SENTRY_FRONTEND_DSN
  if (!dsn) {
    console.warn("Couldn't initialize Sentry: DSN is not provided")
    return
  }

  // Don't enable Sentry during tests to reduce noise
  if (import.meta.env.VITE_DISABLE_SENTRY === "true") {
    return
  }

  sessionStorage[SENTRY_SESSION_KEY] ??= crypto.randomUUID()

  Sentry.init({
    environment: env.ENVIRONMENT_NAME,
    dsn: import.meta.env.VITE_SENTRY_FRONTEND_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Avoid using webworker as our CSP rules prevent this
        useCompression: false,
      }),
      Sentry.captureConsoleIntegration({
        levels: ["error"],
      }),
    ],

    tracesSampleRate: 0.1,
    tracePropagationTargets: [
      // By default sentry only does trace propagation to the the same origin
      // This is needed to capture traces from our apis
      /^https:\/\/api\.(staging\.)?mijnpraktijk\.nl\/api\//,
    ],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })

  Sentry.setUser({ id: sessionStorage[SENTRY_SESSION_KEY] })
}
